
import { useSelector } from "react-redux";

import { Navigate } from "react-router-dom";


const PrivateRoute = ({children}) => {
    const {token} = useSelector((state)=> state.auth)
    if (token) return children

  return <Navigate to={"/giris-yap"}/>
}


export default PrivateRoute